import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

export default class CursorHandler {
	constructor() {
		this.cursor = null;
		this.hoverElements = [];
		this.onMouseEnter = null;
		this.onMouseLeave = null;
	}

	init() {
		if (ScrollTrigger.isTouch !== 1) {
			this.cursor = document.createElement("div");
			this.cursor.classList.add("fixed", "z-[99999]", "top-0", "left-0", "w-4", "aspect-square", "rounded-full", "pointer-events-none", "bg-lime", "transition-[width]");
			document
				.querySelector("main")
				.parentNode.insertBefore(
					this.cursor,
					document.querySelector("main").nextSibling
				);

			gsap.set(this.cursor, {
				xPercent: -100,
				yPercent: -100,
			});

			document.addEventListener("pointermove", (e) => {
				gsap.to(this.cursor, {
					duration: 0.5,
					ease: "power1.out",
					x: e.clientX,
					y: e.clientY,
					yPercent: -50,
					xPercent: -50,
				});
			});
			
			document.addEventListener("mousedown", (e) => {
				this.cursor.classList.add("!w-2");
			});
			
			document.addEventListener("mouseup", (e) => {
				this.cursor.classList.remove("!w-2");
			});

			this.initHovers();
		}
	}

	initHovers() {
		if (!this.cursor) return;

		this.onMouseEnter = () => this.cursor.classList.add("!w-2");
		this.onMouseLeave = () => this.cursor.classList.remove("!w-2");

		this.hoverElements = gsap.utils.toArray("a, button, input, select, textarea");
		this.hoverElements.forEach((el) => {
			el.addEventListener("mouseenter", this.onMouseEnter);
			el.addEventListener("mouseleave", this.onMouseLeave);
		});
	}

	destroy() {
		this.hoverElements.forEach((el) => {
			el.removeEventListener("mouseenter", this.onMouseEnter);
			el.removeEventListener("mouseleave", this.onMouseLeave);
		});
		this.hoverElements = [];
		if (this.cursor) this.cursor.classList.remove("!w-2");
	}
}
